import {IErrorOrError} from "../interfaces/error-or-error.interface";
import {ErrorType} from "../enums/error-type.enum";

// Implement the ErrorOrError class

export class ErrorOrError implements IErrorOrError {
    public code: string;
    public description: string;
    public type: ErrorType;
    public numericType: number;
    public metadata?: Record<string, any>;

    private constructor(
        code: string,
        description: string,
        type: ErrorType,
        metadata?: Record<string, any>
    ) {
        this.code = code;
        this.description = description;
        this.type = type;
        this.numericType = type;
        this.metadata = metadata;
    }

    static failure(
        code: string = "General.Failure",
        description: string = "A failure has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.FAILURE, metadata);
    }

    static unexpected(
        code: string = "General.Unexpected",
        description: string = "An unexpected error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.UNEXPECTED, metadata);
    }

    static validation(
        code: string = "General.Validation",
        description: string = "A validation error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.VALIDATION, metadata);
    }

    static conflict(
        code: string = "General.Conflict",
        description: string = "A conflict error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.CONFLICT, metadata);
    }

    static notFound(
        code: string = "General.NotFound",
        description: string = "A 'Not Found' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.NOTFOUND, metadata);
    }

    static unAuthorized(
        code: string = "General.Unauthorized",
        description: string = "An 'Unauthorized' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.UNAUTHORIZED, metadata);
    }

    static forbidden(
        code: string = "General.Forbidden",
        description: string = "A 'Forbidden' error has occurred.",
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, ErrorType.FORBIDDEN, metadata);
    }

    static custom(
        type: ErrorType,
        code: string,
        description: string,
        metadata?: Record<string, any>
    ): ErrorOrError {
        return new ErrorOrError(code, description, type, metadata);
    }

    toErrorMessage(): string {
      if (this.type == ErrorType.VALIDATION) {
        return this.description;
      }

      switch (this.type) {
        case ErrorType.FORBIDDEN:
          return `You are not authorized to perform this action`
        case ErrorType.UNAUTHORIZED:
          return `You have to be authenticated first to perform this action`
        case ErrorType.NOTFOUND:
          return `Resource you are trying to access is not found`
        default:
          return `Un Expected Error has been occurred`
      }
    }
}
